module.exports = __webpack_public_path__ + "files/422b4a44292baeb78d30f7d8c13a1349.png";